export const SWATCH_TOGGLE = 'color-swatch-toggle';
